module.exports = __webpack_public_path__ + "static/media/design.c3b5d5f5.PNG";